import { DataTableViewOptions } from "@/components/DataTable/Table/DataTableViewOptions";
import type { CellContext, ColumnDef } from "@tanstack/react-table";

export function ActionColumn<T>({
  cell,
}: {
  cell?: ({ row }: CellContext<T, unknown>) => JSX.Element;
}): ColumnDef<T> {
  return {
    accessorKey: "actions",
    header: ({ table }) => (
      <div className="flex justify-end pr-2">
        <DataTableViewOptions table={table} />
      </div>
    ),
    cell: cell ?? (() => null),
  };
}
